import React from 'react'
import { Grid } from 'semantic-ui-react'
import Configurator from './components/Configurator'

const App: React.FC = () => (
  <Grid stackable columns={2} style={{ height: '100vh', overflow: 'none' }}>
    <Grid.Row stretched>
      <Configurator />
    </Grid.Row>
  </Grid>
)

export default App
